/* eslint-disable @typescript-eslint/no-explicit-any */
import { observable, spy } from 'mobx';
import { Observable } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { container } from 'tsyringe';

import type { AppStore } from '../stores';

export enum LOGS_TYPES {
  start = 'start',
  consoleError = 'consoleError',
  consoleWarning = 'consoleWarning',
  consoleLog = 'consoleLog',
  action = 'action',
}

export enum LOGGING_TYPE {
  oneByOne = 'oneByOne',
}

export interface Log {
  type: LOGS_TYPES;
  params?: object;
  time: number;
}

export interface DebugInitArgs {
  url: string;
  loggingType: LOGGING_TYPE;
  console?: {
    log: (...params: any[]) => any;
    warn: (...params: any[]) => any;
    error: (...params: any[]) => any;
  };
}

export function findPath(primitive: any, object: any, path?: any, level = 0): string[] | null {
  if (!path) {
    path = [];
  }

  if (!object) {
    return null;
  }
  if (level === 5) {
    return null;
  }
  for (const [key, value] of Object.entries(object)) {
    if (value === primitive) {
      return [...path, key];
    }
    if (typeof value === 'object' || typeof value === 'function') {
      const newPath = findPath(primitive, value, [...path, key], level + 1);
      if (newPath) {
        return newPath;
      }
    }
  }
  return null;
}

export const send = (url: string, session: string | undefined, log: Log[]): Observable<any> | undefined => {
  try {
    const trace = encodeURI(JSON.stringify(log));
    return ajax({
      url,
      method: 'POST',
      body: `session=${encodeURI(session || '')}&version=1&trace=${trace}`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      },
    });
  } catch (e) {
    console.info(e, log);
  }
};

class DebugLog {
  @observable sessionId?: number;
  @observable isSendingCompleted = true;
  private logs: Log[] = [];
  private session?: string;
  private url?: string;
  private loggingType?: LOGGING_TYPE;

  private addToLog = (type: LOGS_TYPES, params?: object) => {
    const log: Log = { type, params, time: Date.now() };
    this.logs.push(log);
  };

  private sendLogs = () => {
    if (this.isSendingCompleted && this.logs.length) {
      this.isSendingCompleted = false;
      if (this.url) {
        send(this.url, this.session, this.logs)?.subscribe((resp) => {
          this.isSendingCompleted = true;
          this.session = resp.response.sessionId;
        });
      }
      this.logs = [];
    }
    setTimeout(this.sendLogs, 1000);
  };

  public init(initArgs: DebugInitArgs) {
    this.loggingType = initArgs.loggingType;
    this.url = initArgs.url;

    // if (initArgs.console) {
    //   const oldWarn = initArgs.console.warn;
    //   const oldError = initArgs.console.error;
    //
    //   Object.assign(initArgs.console, {
    //     warn: (...args) => {
    //       oldWarn(...args);
    //       this.addToLog(LOGS_TYPES.consoleWarning, args);
    //     },
    //     error: (...args) => {
    //       oldError(...args);
    //       this.addToLog(LOGS_TYPES.consoleError, args);
    //     },
    //   });
    // }

    spy((event) => {
      if (event.type === 'action') {
        try {
          const appStore = container.resolve<AppStore>('appStore');
          const path = findPath(event.object, { appStore }) || [];
          if (!path.length) {
            // remove all clients actions
            return;
          }
          this.addToLog(LOGS_TYPES.action, {
            arguments: event.arguments,
            path: [...path.filter(Boolean), event.name],
          });
        } catch (e) {
          /* empty */
        }
      }
    });
    this.sendLogs();
  }
}

export const debugLog = new DebugLog();
